<template>
    <div class="wisherbg">
        <appheader>

        </appheader>
        <beginning
            :img="this.$store.state.currentwisher"
            :title="peoplepageinfo['beginning_title']"
        >

        </beginning>
        <black
            :text="peoplepageinfo['black_text']"
        >

        </black>
        <firstpart
            :text="peoplepageinfo['first_part']"
        >

        </firstpart>
        <chartpart
            :text="peoplepageinfo['chart_part']"
        >

        </chartpart>
        <videopart
            :text="peoplepageinfo['video_part']"
        >

        </videopart>
        <personalpart
            :text="peoplepageinfo['personal_part']"
        >

        </personalpart>

        <div v-if='voiceShow'><voicepart></voicepart></div>
        <div v-else><voicenone></voicenone></div>

        <progresspart
            :text="peoplepageinfo['progress_part']"
        >

        </progresspart>

        <bottommenu>
        </bottommenu>
        <Footer
            :text="peoplepageinfo['editor']"
        >

        </Footer>
    </div>
</template>

<script>
    import axios from 'axios';

    import appheader from '@/components/header/appheader.vue'

    import beginning from '@/components/wisher/beginning.vue'
    import black from '@/components/wisher/black.vue'
    import firstpart from '@/components/wisher/firstpart.vue'
    import chartpart from '@/components/wisher/chartpart.vue'
    import videopart from '@/components/wisher/videopart.vue'
    import personalpart from '@/components/wisher/personalpart.vue'
    import voicepart from '@/components/wisher/voicepart.vue'
    import voicenone from '@/components/wisher/voicenone.vue'
    import progresspart from '@/components/wisher/progresspart.vue'
    import bottommenu from '@/components/wisher/bottommenu.vue'

    import Footer from '@/components/footer/Footer.vue'
    export default {
        data(){
            return{
                peoplepageinfo: {},
                compnayWisher : [
                    'equality_14','sustainability_5','sustainability_22','sustainability_3','equality_3','aging_3','economy_3','living_3','aging_4','aging_5','education_4'
                ],
                voiceShow:true

            }
        },
        components:{
            appheader,
            beginning,
            black,
            firstpart,
            chartpart,
            videopart,
            voicenone,
            personalpart,
            voicepart,
            progresspart,
            bottommenu,
            Footer
        },
        beforeMount(){
            this.$store.state.currentwisher=this.$route.params.id;
            this.voiceShow = !this.compnayWisher.find(element => element == this.$store.state.currentwisher);
            // console.log("path = "+this.$dataPath);
            axios
            .get("https://p3.udn.com.tw/wish/data/"+this.$store.state.currentwisher+'.json')
            //.get("https://hobbygo.net/wish/data/"+this.$store.state.currentwisher+'.json')
            .then((jsonData) => {
               this.peoplepageinfo=jsonData.data;
            })
            .catch((err) => {
                // console.log("錯誤:", err);
            });

            history.scrollRestoration = "manual";
            window.scrollTo(0,0);
            
        },
        mounted(){
            axios
            .get("https://newmedia.udn.com.tw/active/api/message?flag=Udn70Wish&title="+this.$store.state.currentwisher)
            .then((jsonData) => {
                this.$store.state.heartnum=jsonData.data["data"][0]["userlike"];
            })
            .catch((err) => {
                console.log("錯誤:", err);
            });
        },
        computed:{
            
        }
    }
</script>

<style lang="scss" scoped>
    .wisherbg{
        width: 100%;
        overflow: hidden;
        background-color: #FAFAFA;
    }
</style>